import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SkillBar from "react-skillbars";
import ParticleComponent from "../../Shared/ParticleComponent/ParticleComponent";

const Skill = () => {
    const skill1 = [
      { type: "HTML", level: 95 },
      { type: "CSS", level: 100 },
      { type: "Bootstrap", level: 100 },
      { type:"Tailwind", level: 90},
      { type: "React", level: 85 },
      { type: "Redux", level: 65 },
      { type: "Vue", level: 95 },
      { type:"Nuxt", level:85},
      { type: "Material Ui", level: 85 },

    ];
    const skill2 = [
      { type: "Javascript", level: 95 },
      { type: "C/C++", level: 75 },
      { type: "Python", level: 60},
      { type: "Java", level: 60},
      { type: "Node.js", level: 80 },
      { type:"Express", level:85},
      { type:"GraphQL", level:65},
      { type: "MongoDB", level: 75 },
      { type: "PostgreSQL", level:65}
    ]
    const colors = {
      bar: "#9097d7",
      title: {
        text: "#0000009c",
        background: "#7781e5",
      },
    };
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
    return (
      <div style={{ overflow: "hidden", }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 220">
          <path
            fill="#100028"
            fillOpacity="1"
            d="M0,160L1440,96L1440,320L0,320Z"
          ></path>
        </svg>
        <div style={{ position: "relative"}}>
          <ParticleComponent />
          <h1 data-aos="zoom-in" style={{ color: "#ffffff" }} className="text-center mb-5 headline">
            SKILLS
          </h1>
          <Container>
            <Row>
              <Col data-aos="fade-right" md={6} xs={12} className="pb-md-4">
                <SkillBar skills={skill1} colors={colors} />
              </Col>
              <Col data-aos="fade-left" md={6} xs={12} className="pb-md-4">
                <SkillBar skills={skill2} colors={colors} />
              </Col>
            </Row>
          </Container>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 220">
          <path
            fill="#100028"
            fillOpacity="1"
            d="M0,160L1440,96L1440,0L0,0Z"
          ></path>
        </svg>
      </div>
    );
};

export default Skill;